import shajs from 'sha.js'

const sha256 = (string: string) =>
  shajs('sha256')
    .update(string)
    .digest('hex')

export default sha256
